import { Component, OnInit } from '@angular/core';
import { User } from '../../../models/user/user.module';
import { UserService } from '../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-cambiarcontra',
  templateUrl: './cambiarcontra.component.html',
  styleUrls: ['./cambiarcontra.component.css'],
  providers: [UserService]
})
export class CambiarcontraComponent implements OnInit {0
  identity;
  user: User;
  status: string;
  loading:boolean = false;
  message:string;
  constructor(private _userService: UserService,private _route: ActivatedRoute, private _router: Router) { 
    this.user = new User(1,'','','','','',false)
  }

  ngOnInit(): void {
    this.identity = this._userService.getIdentity();
    if(this.identity != null){
			this._router.navigate(["/"]);
    }
  }
  
  onSubmit(form){
    this.loading = true;
    console.log(this.user);
    this.status == 'success'

    this._userService.recovery_password(this.user).subscribe(
      response => {
        // Token        
        if(response.status == 'success'){
          this.status = 'success';
          this.message = response.message;
          this.loading = false;
        }else{
          this.status = 'error';
          console.log("error");
          this.message = response.message;
          this.loading = false;
        }
      },
      error => {
        this.message = "Error";
        this.status = 'error';
        console.log(<any>error);
        this.loading = false;
      }
    );





  }
}
